import { render, staticRenderFns } from "./linked-companies.vue?vue&type=template&id=0160e668&"
import script from "./linked-companies.vue?vue&type=script&lang=js&"
export * from "./linked-companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports